<template>
    <div>
        <modal :show.sync="dialogVisible" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Ver detalles</h6>
                {{detailsText}}
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="dialogVisible = false">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="dialogVisible = false">Entendido</p-button>
                </div>
            </template>
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    EVALUACIÓN CUALITATIVA Y DE RIESGO
                </h6>
                <br>
                <h6 class="card-title text-center">
                    VOLUNTAD DE PAGO
                </h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Central de Riesgo (Abiertas/Cerradas)</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="Central de Riesgo (Abiertas/Cerradas)"
                                autocomplete="off"
                                v-validate="modelValidations.riskCentralOpenClosed"
                                :error="getError('Central de Riesgo (Abiertas/Cerradas)')"
                                v-model="form.riskCentralOpenClosed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Historial en BMM</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="Historial en BMM"
                                autocomplete="off"
                                v-validate="modelValidations.bmmHistory"
                                :error="getError('Historial en BMM')"
                                v-model="form.bmmHistory">
                    </fg-input>
                </div>
                <br>
                <h6 style="color: white;" class="text-center">
                    Riesgo de la Actividad / Cliente
                </h6>
                <div class="form-group">
                    <label>
                        Riesgo de continuidad del negocio
                        <a href="javascript:void(0)" @click="openDetailsModal('Riesgo de continuidad del negocio')" style="margin-left: 10px; color: orange; cursor: pointer;">
                        Ver detalles
                        </a>
                    </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="Riesgo de continuidad del negocio"
                                autocomplete="off"
                                v-validate="modelValidations.businessContinuityRisk"
                                :error="getError('Riesgo de continuidad del negocio')"
                                v-model="form.businessContinuityRisk">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>
                        Riesgo de inversión ¿Es una nueva actividad?
                        <a href="javascript:void(0)" @click="openDetailsModal('Riesgo de inversión ¿Es una nueva actividad?')" style="margin-left: 10px; color: orange; cursor: pointer;">
                        Ver detalles
                        </a>
                    </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="Riesgo de inversión ¿Es una nueva actividad?"
                                autocomplete="off"
                                v-validate="modelValidations.investmentRiskNewActivity"
                                :error="getError('Riesgo de inversión ¿Es una nueva actividad?')"
                                v-model="form.investmentRiskNewActivity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>
                        Riesgo de mercado
                        <a href="javascript:void(0)" @click="openDetailsModal('Riesgo de mercado')" style="margin-left: 10px; color: orange; cursor: pointer;">
                        Ver detalles
                        </a>
                    </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="Riesgo de mercado"
                                autocomplete="off"
                                v-validate="modelValidations.marketRisk"
                                :error="getError('Riesgo de mercado')"
                                v-model="form.marketRisk">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>
                        Riesgo de potencial endeudamiento
                        <a href="javascript:void(0)" @click="openDetailsModal('Riesgo de potencial endeudamiento')" style="margin-left: 10px; color: orange; cursor: pointer;">
                        Ver detalles
                        </a>
                    </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="Riesgo de potencial endeudamiento"
                                autocomplete="off"
                                v-validate="modelValidations.potentialDebtRisk"
                                :error="getError('Riesgo de potencial endeudamiento')"
                                v-model="form.potentialDebtRisk">
                    </fg-input>
                </div>
                <br>
                <h6 style="color: white;" class="text-center">
                    OBSERVACIONES
                </h6>
                <br>
                <div class="form-group">
                <textarea   class="form-control"
                            tabindex="6"
                            type="text"
                            name="Observaciones"
                            autocomplete="off"
                            v-validate="modelValidations.observations"
                            :error="getError('Observaciones')"
                            v-model="form.observations">
                </textarea>
                <span v-show="errors.has('Observaciones')" class="text-danger" style="font-size: 11px;">
                    {{ errors.first('Observaciones') }}
                </span>
            </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="finishData()" type="warning">Siguiente</p-button>
                    <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
                </div>
            </div>
        </card>

    </div>
</template>
    <script>
    import fab from 'vue-fab'
    import swal from 'sweetalert2'
    import { Card, Modal } from 'src/components/UIComponents'
    import Vue from 'vue'
    import {Select, Option , DatePicker, TimeSelect} from 'element-ui'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import moment from 'moment'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import { parse } from 'expression-eval'
    import { isEmpty } from 'lodash';
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            VueNumeric,
            PSwitch,
            fab,
            Modal,
            [DatePicker.name]: DatePicker,
            [TimeSelect.name]: TimeSelect,
        },
        data() {
        return {
            form: {
                riskCentralOpenClosed: '',         // Central de Riesgo (Abiertas/Cerradas)
                bmmHistory: '',                    // Historial en BMM
                businessContinuityRisk: '',        // Riesgo de continuidad del negocio
                investmentRiskNewActivity: '',     // Riesgo de inversión ¿Es una nueva actividad?
                marketRisk: '',                    // Riesgo de mercado
                potentialDebtRisk: ''    ,          // Riesgo de potencial endeudamiento
                observations: ''
            },
            dialogVisible: false,
            detailsText: null,
            // modelValidations: {
            //     riskCentralOpenClosed: { required: true, max: 2000 },         // Central de Riesgo (Abiertas/Cerradas)
            //     bmmHistory: { required: false, max: 2000 },                    // Historial en BMM
            //     businessContinuityRisk: { required: true, max: 2000 },        // Riesgo de continuidad del negocio
            //     investmentRiskNewActivity: { required: true, max: 2000 },     // Riesgo de inversión ¿Es una nueva actividad?
            //     marketRisk: { required: true, max: 2000 },                    // Riesgo de mercado
            //     potentialDebtRisk: { required: true, max: 2000 },              // Riesgo de potencial endeudamiento
            //     observations: { required: false, max: 2000 },
            // }
        }
        },
        computed: {
          modelValidations() {
              const amount = this.$store.state.assesments[this.$store.state.actualAssesment].amount;
              const isHighAmount = amount > 20000000;
              return {
                  riskCentralOpenClosed: { required: isHighAmount, max: 2000 },
                  bmmHistory: { required: false, max: 2000 },
                  businessContinuityRisk: { required: isHighAmount, max: 2000 },
                  investmentRiskNewActivity: { required: isHighAmount, max: 2000 },
                  marketRisk: { required: isHighAmount, max: 2000 },
                  potentialDebtRisk: { required: isHighAmount, max: 2000 },
                  observations: { required: false, max: 2000 },
              };
          }
      },
        methods: {
            openDetailsModal(details) {
                const detailsMap = {
                "Riesgo de continuidad del negocio": {text: "Evaluar el nivel de dependencia en el funcionamiento del negocio por parte del titular, concentración de proveedores y clientes, daños en la infraestructura física o maquinaria y equipo que impida el normal funcionamiento del negocio" },
                "Riesgo de inversión ¿Es una nueva actividad?": {text: "Evaluar conocimiento, experiencia del cliente en la nueva actividad, retorno de la inversión y administración del nuevo negocio" },
                "Riesgo de mercado": {text: "Evaluar el impacto dela competencia en la continuidad y/o disminución de ingresos en el negocio y entorno donde se desarrolla la actividad" },
                "Riesgo de potencial endeudamiento": {text: "Evaluar (Manejo de TDC, huellas de consulta y desembolsos recientes, escalonamiento acelerado de los créditos)" }
                };

                // Si el nombre que llega en `details` existe en el JSON, asigna el texto correspondiente
                if (detailsMap[details]) {
                this.detailsText = detailsMap[details].text;
                } else {
                this.detailsText = "Detalles no disponibles";  // Texto por defecto si no coincide
                }

                // Abre el modal (puedes llamar a un método que lo haga visible)
                this.dialogVisible = true;
            },
            validateGuarantors () {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors.length > 0) {
                    return true
                }
                else if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors.length == 0) {
                    this.form.guarantor.reference.first_name= '';
                    this.form.guarantor.reference.second_first_name= '';
                    this.form.guarantor.reference.last_name= '';
                    this.form.guarantor.reference.second_last_name= '';
                    this.form.guarantor.reference.home_address= '';
                    this.form.guarantor.reference.home_state= '';
                    this.form.guarantor.reference.home_city= '';
                    this.form.guarantor.reference.linkage= '';
                    this.form.guarantor.reference.phone1= '';
                    this.form.guarantor.reference.phone2= '';
                    this.form.guarantor.reference.job_address= '';
                    this.form.guarantor.reference.job= '';
                    this.form.guarantor.reference.job_phone= '';
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toFM100() {
                this.$router.push('/asessments/new_asessment/customer/fm100');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toER () {

            },

            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (product.name.toLowerCase() == 'consumo') {
                    this.consumer = true;
                    this.microcredit = false;
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                        var purpose = this.$store.getters.getCreditPurposes.find(purpose => purpose.name.toLowerCase() == 'libre inversión' || purpose.name.toLowerCase() == 'libre inversion');
                        this.requestCreditPurpose = purpose.id;
                    }
                }
                else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                    this.microcredit = true;
                    this.consumer = false;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función para mostrar un mensaje de éxito
            */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            finishData () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.$store.dispatch('setWillingnessToPay', this.form).then(()=>{
                            var payload = {
                                stage: 'Registro de Formulario',
                                description: 'Se ingresan datos del formulario Evaluación cualitativa de riesgo.',
                                dateTime: moment().format()
                            };
                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm102.length > 0) {
                                    this.$router.push('/asessments/menu');
                                }
                                else {
                                    var vm = this;
                                    swal({
                                        title: '¿Deseas agregar información al FM102?',
                                        text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        var payload = {
                                            client: 'customer',
                                            actualAssesment: vm.$store.state.actualAssesment,
                                            actualStudy: 0
                                        }
                                        vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                            vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/fm102');
                                            });
                                        });

                                    }, function (dismiss) {
                                        vm.$router.push('/asessments/menu');
                                    })
                                }
                            });
                        });
                    }
                    else {
                        this.showNotificationError('Algunos campos son erróneos, revisa y continúa');
                        // window.scroll(0, 0);
                        this.$el.querySelector('[name="' + this.$validator.errors.items[0].field + '"]').focus();
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].amount == 0) {
                            this.showNotificationError('El monto a solicitar no puede ser 0');
                            return
                        }
                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                        var payload = {
                            stage: 'Ingreso de datos de negocio',
                            description: 'Se ingresan los datos del negocio.',
                            dateTime: moment().format()
                        };
                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                            if (this.microcredit) {
                                if (subcategory == 'catalogo') {
                                    this.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                                }
                                else {
                                    this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                                }
                            }
                            else if(this.consumer) {
                                this.$router.push('/asessments/new_asessment/customer/others/business_references');
                            }

                        });
                    }
                    else {
                        this.showNotificationError('El formulario no está completo');
                    }
                })


            }
        },
        mounted() {
            if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.willingnessToPay.length > 0) {
                var form = JSON.parse(JSON.stringify(this.$store.state.assesments[this.$store.state.actualAssesment].customer.willingnessToPay[0]));
                this.$data.form = form;
            }
        }
    }
</script>
<style>
.fab-main .material-icons{
    color: black !important;
    background-color: #F09500 !important;
}
.fab-list li .material-icons{
    color: black !important;
    font-family: "Helvetica Neue" !important;
    font-size: 12px !important;
}
.center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
.orange {
    color: #F09500;
}
.white {
    color: white;
}
</style>
